<template>
  <div class="flex flex-col gap-8 w-full">
    <div class="flex items-center justify-center w-9/12 mx-auto">
      <PirateFigure
        :image="activeCharacter?.image"
        blackShadow
        bigShadow
        class="!h-[280px] !w-full"
      ></PirateFigure>
    </div>
    <PowButton 
      @click="router.push({ name: 'EditCharacterView' })"
      tertiary
      class="w-full z-10"
    >Edit Character</PowButton>
  </div>
</template>
<script setup>
import PirateFigure from '@/components/PirateFigure.vue'
import PowButton from '@/components/PowButton.vue'
import { useRouter } from 'vue-router'
import { useGameStore } from '@/stores/game'
import { computed } from 'vue'

const gameStore = useGameStore()

const activeCharacter = gameStore.getActiveCharacter()
const router = useRouter()
</script>
